import { Container } from 'unstated'
import SendGAEvent from '../GoogleAnalytics'


class AppContainer extends Container {
  state = {
    menuIsOpen: false,
    modalOverlayIsOpen: false,
    contactModalIsOpen: false,
    gartnerModalIsOpen:false,
  }

  showModalOverlay = () => {
    this.setState({ modalOverlayIsOpen: true })
  }

  hideModalOverlay = () => {
    this.setState(prevState => {
      if (!prevState.contactModalIsOpen && !prevState.gartnerModalIsOpen) return { modalOverlayIsOpen: false }
    })
  }

  openMenu = () => {
    this.setState({ menuIsOpen: true })
  }

  closeMenu = () => {
    this.setState({ menuIsOpen: false })
  }

  openContactModal = () => {
    this.setState({ modalOverlayIsOpen: true, contactModalIsOpen: true })
    SendGAEvent('Contactform', 'opened', typeof window !== `undefined` ? window.location.href : '')
  }

  closeContactModal = () => {
    this.setState({ modalOverlayIsOpen: false, contactModalIsOpen: false })
  }

    openGartnerModal = () => {
    this.setState({ modalOverlayIsOpen: true, gartnerModalIsOpen: true })
    SendGAEvent('Gartnerform', 'opened', typeof window !== `undefined` ? window.location.href : '')
  }

    closeGartnerModal = () => {
    this.setState({ modalOverlayIsOpen: false, gartnerModalIsOpen: false })
  }



}

// A single shared instance, passed to the unstated <Provider> via `inject`
// (see src/components/Layout/index.js).
//
// This is required: unstated v2 <Provider> creates a fresh context Map from the
// parent context value on every render. The outermost provider's parent value is
// null, so without an injected instance every re-render of <Provider> (e.g. any
// page re-render while the Gatsby dev server is running — Gatsby 5 full page
// loads are triggered simply by hovering an internal <Link>) would cause every
// <Subscribe> to instantiate a brand-new AppContainer, silently resetting all
// state (menuIsOpen, modal flags) and e.g. closing the navigation modal the
// moment a menu item is hovered.
const appContainer = new AppContainer()

export { appContainer }
export default AppContainer
